import Menu from './Menu'
import MenuLink from './MenuLink'
import BaseLink from './BaseLink'

Menu.Link = MenuLink
Menu.BaseLink = BaseLink

export default Menu
